import { React, useEffect, useState } from "react";
import { Steps } from "primereact/steps";
import _ from "lodash";

export default function ProgressSteps(props) {
	const [items, setItems] = useState([]);
	const [activeIndex, setActiveIndex] = useState(0);

	useEffect(() => {
		if (props.winWorkStage.length > 0 && !_.isEmpty(props.opportunityData)) {
			const openIndex = props.opportunityData.gateways?.gateway_status.findIndex(
				(status) => status.status === 'open'
			);

			if (openIndex !== -1) {
				setActiveIndex(openIndex);
			} else {
				setActiveIndex(0)
			}

			const i = props.winWorkStage.map((stage, index) => ({
				label: stage.text,
				disabled: props.isStop || !props.statusPrivilege,
				icon: props.opportunityData.gateways?.gateway_status[index]?.status === 'closed' && props.planType !== 'Free' ? 'pi pi-lock' : null,
			}));

			setItems(i);
		}
	}, [props.winWorkStage, props.opportunityData, props.isStop, props.statusPrivilege, props.planType]);

	useEffect(() => {
		document.querySelectorAll('.p-steps-item').forEach(item => {
			const lockIcon = item.querySelector('.pi-lock');
			const stepNumber = item.querySelector('.p-steps-number');

			if (lockIcon && stepNumber) {
				stepNumber.style.display = 'none';
			}
		});
	}, [items])

	return (
		<div className="portfolio-steps">
			<Steps
				key={activeIndex}
				model={items}
				readOnly={true}
				activeIndex={activeIndex}
			/>
		</div>
	);
}